var exports = {
  "O": "x31de4314--a2e675--underground",
  "d": "x31de4314--a2e675--underground-station",
};

module.exports = exports;
